import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

/** @component
 * Container for a given page section
 *
 * A page section is a set of grouped containers with a close visual spacing,
 * to visually group them together.
 *
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<{readonly children?: *}> & React.RefAttributes<unknown>>}
 */
const PageSection = forwardRef(({ children }, ref) => {
    return (
        <Grid
            ref={ref}
            container
            spacing={3}
            flexDirection={{ xs: 'column', sm: 'row' }}
            alignContent={'center'}
        >
            {children}
        </Grid>
    );
});

PageSection.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node)
};

PageSection.displayName = 'PageSection';

export default PageSection;
